import { IndexType } from "~/enums/objectModelPropertyIndexType";
import scrollToElement from "~/helpers/scrollToElement";
import { ValidationModalSection } from "~/models/navigableValidations/validationSections";
import ObjectModelIndexCapValidator from "~/models/navigableValidators/objectModelIndexCapValidator";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import EmbeddedCollectionValidator from "../navigableValidators/embeddedCollectionValidator";
import FieldPresenceValidator from "../navigableValidators/fieldPresenceValidator";
import ObjectModelPropertiesValidator from "../navigableValidators/objectModelPropertiesValidator";
import ObjectModelRelationsValidator from "../navigableValidators/objectModelRelationsValidator";
import ObjectModelTriggersValidator from "../navigableValidators/objectModelTriggersValidator";
import ObjectModel from "../objectModel";
import NavigableValidation from "./navigableValidation";

export default class ObjectModelBuilderValidation extends NavigableValidation<ObjectModel> {
  validators = [
    new ObjectModelPropertiesValidator({
      validatorKey: 'object_model_properties',
      section: ValidationModalSection.Properties
    }),
    new ObjectModelRelationsValidator({
      validatorKey: 'object_model_relations',
      section: ValidationModalSection.Properties,
    }),
    new ObjectModelIndexCapValidator({
      validatorKey: 'object_model_text_index_cap',
      section: ValidationModalSection.Properties,
      beforeReveal: async  () => {
        await window.requestAnimationFrame(async () => {
          await this.scrollToLastIndexedPropOfIndexType(IndexType.Keyword);
        })
      },
    },
      IndexType.Keyword
    ),
    new ObjectModelIndexCapValidator({
        validatorKey: 'object_model_number_index_cap',
        section: ValidationModalSection.Properties,
        beforeReveal: async  () => {
          await window.requestAnimationFrame(async () => {
            await this.scrollToLastIndexedPropOfIndexType(IndexType.Double);
          })
        },
      },
      IndexType.Double
    ),
    new ObjectModelIndexCapValidator({
        validatorKey: 'object_model_date_index_cap',
        section: ValidationModalSection.Properties,
        beforeReveal: async  () => {
          await window.requestAnimationFrame(async () => {
            await this.scrollToLastIndexedPropOfIndexType(IndexType.Date);
          })
        },
      },
      IndexType.Date
    ),
    new ObjectModelTriggersValidator({
      validatorKey: 'object_model_triggers',
      section: ValidationModalSection.Triggers
    }),
    new EmbeddedCollectionValidator({
      validatorKey: "object_model_limits",
      section: ValidationModalSection.Settings
    }, this.model),
    // Dashboard validations
    new FieldPresenceValidator({
      validatorKey: 'dashboard_name',
      section: ValidationModalSection.Settings,
      conditional: (model: ObjectModel, validatorKey) => {
        return model.dashboard_display_enabled && !model.dashboard_name_property_client_id
      },
    }),
    new FieldPresenceValidator({
      validatorKey: 'dashboard_number_property_client_id',
      section: ValidationModalSection.Settings,
      conditional: (model: ObjectModel, validatorKey) => {
        return model.dashboard_display_enabled
      },
    }),
    new FieldPresenceValidator({
      validatorKey: 'dashboard_expiration_property_client_id',
      section: ValidationModalSection.Settings,
      conditional: (model: ObjectModel, validatorKey) => {
        return model.dashboard_display_enabled
      },
    }),
    new FieldPresenceValidator({
      validatorKey: 'dashboard_status_property_client_id',
      section: ValidationModalSection.Settings,
      conditional: (model: ObjectModel, validatorKey) => {
        return model.dashboard_display_enabled
      },
    }),
    new EmbeddedCollectionValidator({
      validatorKey: "dashboard_conditional_linked_detail_views",
      section: ValidationModalSection.Settings,
      conditional: (model: ObjectModel, validatorKey) => {
        return model.dashboard_display_enabled && model.dashboard_linked_detail_view_rule_enabled
      },
    }, this.model),
    new FieldPresenceValidator({
      validatorKey: 'dashboard_conditional_fallback_linked_detail_view_id',
      section: ValidationModalSection.Settings,
      conditional: (model: ObjectModel, validatorKey) => {
        return model.dashboard_display_enabled && model.dashboard_linked_detail_view_rule_enabled
      },
    }),

  ];
  async scrollToLastIndexedPropOfIndexType(indexType: IndexType): Promise<JQuery> {
    const indexedPropertiesOfType = this.model.indexedProperties.filter(prop=>{
      return ObjectModelProperty.getPropertyIndexType(prop) === indexType
    })
    const lastProperty = indexedPropertiesOfType[indexedPropertiesOfType.length-1]
    const $label = $(`[data-id="${lastProperty.client_id}"]`);

    await scrollToElement({
      offset: -20,
      $el: $label,
      $container: $("div.scroll-area.work-area"),
      relative: true
    })
    $label.trigger("click")
    return $label;
  }
}